import * as toggle from "@otto-ec/global-resources/toggle";

/**
 *
 */
export const metricPrefix = "rum_";

/*                                                                       */
export type RawRumData = Record<string, string | number | boolean>;


/**
 *
 *
 *
 *
 *
 */
export const isNotEmptyObject = <T>(value: T): value is NonNullable<T> =>
    value &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    Object.keys(value).length > 0;

/**
 *
 */
export const isToggleActive = (toggleName: string): boolean =>
    toggle.get(toggleName, false);

/**
 *
 */
export function capitalizeFirstLetterAfterPrefix(given: string): string {
    const data = given.startsWith(metricPrefix)
        ? {idx: metricPrefix.length, prefix: metricPrefix}
        : {idx: 0, prefix: ""};

    return data.prefix + capitalizeFirstLetter(given.slice(data.idx));
}

const capitalizeFirstLetter = (given: string): string =>
    given.charAt(0).toUpperCase() + given.slice(1);

export const prefixMetricKey = (metricKey: string): string =>
    metricKey.startsWith(metricPrefix)
        ? metricKey
        : `${metricPrefix}${metricKey}`;

export const capitalizeAndPrefixKeys = (rumData: RawRumData): RawRumData =>
    transformObject(rumData, (entries) =>
        entries.map(([key, value]) => [
            prefixMetricKey(capitalizeFirstLetterAfterPrefix(key)),
            value,
        ]),
    );


/**
 *
 *
 *
 *
 *
 */
export const transformObject = <T, R>(
    input: T,
    transformEntries: (
        entries: [key: keyof T, T[keyof T]][],
    ) => [keyof R, R[keyof R]][],
): R => Object.fromEntries(transformEntries(Object.entries(input))) as R;
